import Teachr from "../../Objects/models/Teachr";

const SET_INFO = "SET_TEACHR_INFO";
const DELETE_TEACHR_INFO = "DELETE_TEACHR_INFO";
const SET_ADDRESS = "SET_ADDRESS";
const RESET_ADDRESS = "RESET_ADDRESS";

const initialState: any = null;

export default function teachrReducer(state = initialState, action: any) {
  switch (action.type) {
    case SET_INFO:
      return action.payload;

    case SET_ADDRESS:
       return {...state, address: action.payload};
    case RESET_ADDRESS:
       return null;

    case DELETE_TEACHR_INFO:
      return null;
    default:
      return state;
  }
}
